var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.219 4C16.8778 4 16.5366 4.13029 16.2763 4.39063L14.6669 6.00004L18.0003 9.33344L19.6097 7.72403C20.1304 7.20335 20.1304 6.35925 19.6097 5.83858L18.1617 4.39063C17.9014 4.13029 17.5602 4 17.219 4ZM13.3335 7.3334L5.50654 15.1604C5.50654 15.1604 6.1184 15.1055 6.3464 15.3336C6.5744 15.5616 6.38671 17.0536 6.66672 17.3336C6.94672 17.6136 8.42935 17.4165 8.64202 17.6292C8.85469 17.8418 8.83994 18.4938 8.83994 18.4938L16.6669 10.6668L13.3335 7.3334ZM4.66668 17.3336L4.03776 19.1149C4.01304 19.1852 4.00027 19.2591 4 19.3336C4 19.5104 4.07024 19.68 4.19527 19.805C4.32029 19.9301 4.48987 20.0003 4.66668 20.0003C4.7412 20 4.81514 19.9873 4.88543 19.9626C4.88761 19.9617 4.88978 19.9608 4.89194 19.9599L4.90887 19.9547C4.91018 19.9539 4.91148 19.953 4.91278 19.9521L6.66672 19.3336L5.6667 18.3336L4.66668 17.3336Z",
    fill: "#00BFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEditIcon);
export default __webpack_public_path__ + "static/media/input-edit-icon.a39629b2dc81a6d16fe333cefbae138f.svg";
export { ForwardRef as ReactComponent };